import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {EffectsModule} from '@ngrx/effects';
import {RouterStateSerializer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {ActionReducerMap, MetaReducer, StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '../../../environments/environment';
import {ActionsEffects} from './actions/actions.effects';
import {actionsReducer} from './actions/actions.reducer';
import {ActiveUserEffects} from './active-user/active-user.effect';
import {activeUserReducer} from './active-user/active-user.reducer';
import {AppState, initialAppState} from './app-state';
import {ChallengeBuilderEffects} from './challenge-builder/challenge-builder.effects';
import {challengeBuilderReducer} from './challenge-builder/challenge-builder.reducer';
import {CommonEffects} from './common/common.effects';
import {commonMetaReducer} from './common/common.meta-reducer';
import {CurrentSkedEffects} from './current-sked/current-sked.effects';
import {currentSkedReducer} from './current-sked/current-sked.reducer';
import {GoalsEffects} from './goals/goals.effects';
import {goalsReducer} from './goals/goals.reducer';
import {LensesEffects} from './lenses/lenses.effects';
import {lensesReducer} from './lenses/lenses.reducer';
import {LocationsEffects} from './locations/locations.effects';
import {locationsReducer} from './locations/locations.reducer';
import {ProgramsEffects} from './programs/programs.effects';
import {programsReducer} from './programs/programs.reducer';
import {ProjectsEffects} from './projects/projects.effects';
import {projectsReducer} from './projects/projects.reducer';
import {ReportingEffects} from './reporting/reporting.effects';
import {reportingReducer} from './reporting/reporting.reducer';
import {RewardsEffects} from './rewards/rewards.effects';
import {rewardsReducer} from './rewards/rewards.reducer';
import {RolesEffects} from './roles/roles.effects';
import {rolesReducer} from './roles/roles.reducer';
import {customRouterReducer} from './router/router.reducer';
import {CustomRouterStateSerializer} from './router/router.state';
import {ScheduleEffects} from './schedule/schedule.effects';
import {scheduleReducer} from './schedule/schedule.reducer';
import {SchedulerEffects} from './scheduler/scheduler.effects';
import {schedulerReducer} from './scheduler/scheduler.reducer';
import {SkillsEffects} from './skills/skills.effects';
import {skillsReducer} from './skills/skills.reducer';
import {TeamsEffects} from './teams/teams.effects';
import {teamsReducer} from './teams/teams.reducer';
import {TokensEffects} from './tokens/tokens.effects';
import {tokensReducer} from './tokens/tokens.reducer';
import {TrackersEffects} from './trackers/trackers.effects';
import {trackersReducer} from './trackers/trackers.reducer';
import {UsersEffects} from './users/users.effects';
import {usersReducer} from './users/users.reducer';
import {wikiReducer} from './wiki/wiki.reducer';
import {WikiEffects} from './wiki/wiki.effects';
import {AlertsEffects} from './alerts/alerts.effects';
import {alertsReducer} from './alerts/alerts.reducer';

const reducers: ActionReducerMap<AppState> = {
  activeUser: activeUserReducer,
  alerts: alertsReducer,
  challengeBuilder: challengeBuilderReducer,
  roles: rolesReducer,
  router: customRouterReducer,
  scheduler: schedulerReducer,
  skills: skillsReducer,
  users: usersReducer,
  programs: programsReducer,
  locations: locationsReducer,
  actions: actionsReducer,
  teams: teamsReducer,
  reporting: reportingReducer,
  currentSked: currentSkedReducer,
  lenses: lensesReducer,
  schedule: scheduleReducer,
  goals: goalsReducer,
  trackers: trackersReducer,
  projects: projectsReducer,
  rewards: rewardsReducer,
  tokens: tokensReducer,
  wiki: wikiReducer,
};

const metaReducers: MetaReducer<AppState>[] = [commonMetaReducer];

const effects = [
  CommonEffects,
  RolesEffects,
  SchedulerEffects,
  SkillsEffects,
  UsersEffects,
  ProgramsEffects,
  LocationsEffects,
  ActionsEffects,
  TeamsEffects,
  ReportingEffects,
  CurrentSkedEffects,
  LensesEffects,
  ScheduleEffects,
  GoalsEffects,
  ActiveUserEffects,
  TrackersEffects,
  ProjectsEffects,
  RewardsEffects,
  TokensEffects,
  WikiEffects,
  AlertsEffects,
  ChallengeBuilderEffects,
];

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      initialState: initialAppState,
      metaReducers,
      runtimeChecks: {
        strictActionImmutability: false, // TODO change to true once this is fixed: https://github.com/ngrx/platform/issues/2690,
        strictStateImmutability: false, // TODO change to true once this is fixed: https://github.com/ngrx/platform/issues/2690,
      },
    }),
    EffectsModule.forRoot(effects),
    StoreRouterConnectingModule.forRoot(),
    environment.storeDevtools
      ? StoreDevtoolsModule.instrument({maxAge: 50, name: `Ophanim NgRx Store`, connectInZone: true})
      : [],
    MatButtonModule,
    CommonModule,
  ],
  providers: [
    {
      provide: RouterStateSerializer,
      useClass: CustomRouterStateSerializer,
    },
  ],
})
export class AppStoreModule {}
